import React from 'react';
import '../styles/App.css';
import '../styles/Widget.css';
import Login from './Login';

function App() {
	return(<div id="app">
		<Login />
	</div>);
}

export default App;
